import { GetBodyImagesTabsQueryParamsType } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyImagesTabs/getBodyImagesTabsQuery.type';
import { getBodyImagesTabsQueryFunction } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyImagesTabs/getBodyImagesTabsQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getBodyImagesTabsQueryOptions = (
  params: GetBodyImagesTabsQueryParamsType,
) => {
  return queryOptions({
    queryKey: ['GET_BODY_IMAGE_TABS', params],
    queryFn: () => getBodyImagesTabsQueryFunction(params),
  });
};
